/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import { PhrMeasurement, PhrMeasurementFromJSON, PhrMeasurementFromJSONTyped, PhrMeasurementToJSON } from "./";

export const PhrGOTsTypename = "PhrGOTs" as const;

/**
 *
 * @export
 * @interface PhrGOTs
 */
export interface PhrGOTs {
  /**
   *
   * @type {PhrMeasurement}
   * @memberof PhrGOTs
   */
  other?: PhrMeasurement;
  /**
   *
   * @type {PhrMeasurement}
   * @memberof PhrGOTs
   */
  ultravioletVisibleAbsorptionSpectroscopy?: PhrMeasurement;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrGOTs
   */
  readonly __typename?: string;
}

export function PhrGOTsFromJSON(json: any): PhrGOTs {
  return PhrGOTsFromJSONTyped(json, false);
}

export function PhrGOTsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhrGOTs {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrGOTsTypename,

    other: !exists(json, "other") ? undefined : PhrMeasurementFromJSON(json["other"]),
    ultravioletVisibleAbsorptionSpectroscopy: !exists(json, "ultraviolet_visible_absorption_spectroscopy")
      ? undefined
      : PhrMeasurementFromJSON(json["ultraviolet_visible_absorption_spectroscopy"]),
  };
}

export function PhrGOTsToJSON(object?: PhrGOTs | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    other: PhrMeasurementToJSON(value.other),
    ultraviolet_visible_absorption_spectroscopy: PhrMeasurementToJSON(value.ultravioletVisibleAbsorptionSpectroscopy),
  };
}
